import React from "react";
import { Spinner } from "flowbite-react";

const CardSpinner = () => {
  return (
    <div className="w-full aspect-[3/4] bg-gray-200 rounded-lg flex items-center justify-center">
     <Spinner aria-label="Extra large spinner example" size="xl" />
    </div>
  );
};

export default CardSpinner;
